import { styled } from "@mui/material";
import { Button, Notification } from "@pmag/ui-components";

export const Root = styled(Button)(({ theme }) => ({
    minWidth: 120,
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
        height: "32px",
    },
}));

export const StyledNotification = styled(Notification)(({ theme }) => ({
    [theme.breakpoints.down("md")]: {
        width: 300,
    },
}));
